import { render, staticRenderFns } from "./UploadFileButton.vue?vue&type=template&id=584aeed1&scoped=true"
import script from "./UploadFileButton.vue?vue&type=script&lang=ts"
export * from "./UploadFileButton.vue?vue&type=script&lang=ts"
import style0 from "./UploadFileButton.vue?vue&type=style&index=0&id=584aeed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584aeed1",
  null
  
)

export default component.exports